import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { identity } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
  bar: makeThemeColor(PRIMARY, 0.3),
  text: makeThemeColor(PRIMARY),
};

export const HEIGHT = {
  [HD]: 48,
  [FULL_HD]: 56,
};

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const HORIZONTAL_PADDING = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const VERTICAL_PADDING = {
  [HD]: 12,
  [FULL_HD]: 12,
};

export const GAP = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  const primaryFont = getFont(FONT.BERLIN_3, screenSize);
  const secondaryFont = getFont(FONT.BERLIN_1, screenSize);

  return {
    h: HEIGHT[screenSize],
    Background: {
      w: identity,
      h: HEIGHT[screenSize],
      shader: {
        fillColor: colors.background[colorMode],
        progressColor: colors.bar[colorMode],
        radius: Math.round(HEIGHT[screenSize] / 2),
      },
    },
    Icon: {
      iconData: {
        picto: { name: 'Play', type: 'icon' },
        viewBox: {
          h: ICON_HEIGHT[screenSize],
        },
      },
      y: Math.round((HEIGHT[screenSize] - ICON_HEIGHT[screenSize]) / 2),
    },
    Primary: {
      color: colors.text[colorMode],
      y: Math.round((HEIGHT[screenSize] - primaryFont.lineHeight) / 2),
      text: {
        ...primaryFont,
        verticalAlign: 'middle',
        wordWrap: false,
      },
    },
    Secondary: {
      color: colors.text[colorMode],
      y: Math.round((HEIGHT[screenSize] - secondaryFont.lineHeight) / 2),
      text: {
        ...secondaryFont,
        verticalAlign: 'middle',
        wordWrap: false,
      },
    },
  };
};
